import PaymentStatusCard from "../../../Components/PaymentStatusCard";

const PaymentSuccess = () => <PaymentStatusCard status="success" />;

export default PaymentSuccess;
